/* eslint-disable react/prefer-stateless-function */

import React from 'react';

const ModalFooter = (props) => <div className="modal-footer cfix">{props.children}</div>;

ModalFooter.defaultProps = {
  children: [],
};

export default ModalFooter;
